import FormComponent from "./form.js";
import FormControl from "./form-control.js";
import FormFeedback from "./form-feedback.js";
import FormItem from "./form-item.js";
import FormLabel from "./form-label.js";
import FormList from "./form-list.js";
export { default as useFormField } from "./use-form-field.js";
export { default as useFormValue } from "./use-form-value.js";
const Form = FormComponent;
Form.Item = FormItem;
Form.Label = FormLabel;
Form.Control = FormControl;
Form.Feedback = FormFeedback;
Form.List = FormList;
export default Form;
